export default {
  'nav.home': '首頁',
  'nav.about': '公司簡介',
  'nav.advantages': '核心優勢',
  'nav.products': '產品體系',
  'nav.products.overview': '產品總覽',
  'nav.products.cex': '中心化交易所',
  'nav.products.rwa': 'RWA 解決方案',
  'nav.products.wallet': '錢包類產品',
  'nav.products.staking': '質押類產品',
  'nav.products.mining': '挖礦類產品',
  'nav.services': '服務',
  'nav.services.overview': '服務總覽',
  'nav.services.overseasFund': '海外基金設立',
  'nav.services.financialLicensing': '金融牌照申請',
  'nav.services.overseasCompany': '海外公司設立',
  'nav.services.mergersAcquisitions': '公司併購',
  'nav.news': '新聞動態',
  'nav.contact': '聯繫我們',
  'nav.cta': '立即諮詢',

  'hero.tag': '產業區塊鏈 & Web3 全棧解決方案',
  'hero.title1': '賦能企業 Web3 轉型',
  'hero.title2': '構建可信數字未來',
  'hero.subtitle': '新加坡總部 · 模塊化架構 · 技術即服務',
  'hero.cta1': '探索解決方案',
  'hero.cta2': '查看產品體系',

  'stats.years': '8+',
  'stats.years.label': '年安全服務經驗',
  'stats.clients': '50+',
  'stats.clients.label': '企業合作客戶',
  'stats.projects': '200+',
  'stats.projects.label': '項目成功交付',
  'stats.support': '24/7',
  'stats.support.label': '全天候技術支持',

  'about.tag': '公司簡介',
  'about.title': '新加坡總部 · 全球服務',
  'about.desc1': '我們是一家總部位於新加坡的產業區塊鏈與 Web3 創新科技服務公司，專注於為企業提供全棧區塊鏈解決方案。',
  'about.desc2': '團隊由資深區塊鏈專家、工程師和 Web3 顧問組成，秉持「技術即服務」的核心理念，致力於推動實體經濟與 Web3 的深度融合。',
  'about.desc3': '產品體系涵蓋中心化交易所、RWA 資產代幣化、去中心化錢包、DApp 定制開發等核心領域。',
  'about.badge': '新加坡註冊',
  'about.badge2': '2023 年成立',
  'about.more': '了解更多',

  'services.tag': '核心服務',
  'services.title': '四大核心服務領域',
  'services.cex.title': '中心化交易所 CEX',
  'services.cex.desc': '全棧 CEX 系統開發，訂單撮合引擎、KYC/AML 合規、多端支持，彈性擴容至百萬 TPS。',
  'services.cex.f1': '高性能撮合引擎',
  'services.cex.f2': 'KYC/AML 合規',
  'services.cex.f3': '多端 PC/H5',
  'services.wallet.title': '錢包 + IM 系統',
  'services.wallet.desc': '多鏈去中心化錢包與社交 IM 融合，支持 DApp 瀏覽器、NFT 管理與 DAO 治理。',
  'services.wallet.f1': '多鏈資產管理',
  'services.wallet.f2': 'DApp 瀏覽器',
  'services.wallet.f3': 'NFT 市場',
  'services.rwa.title': 'RWA 資產代幣化',
  'services.rwa.desc': '將房地產、藝術品、供應鏈等實物資產上鏈，實現合規確權、智能合約分紅與全球流通。',
  'services.rwa.f1': '法律合規確權',
  'services.rwa.f2': '智能合約分紅',
  'services.rwa.f3': '全球合格投資者',
  'services.dapp.title': 'DApp 定制開發',
  'services.dapp.desc': '質押、流動性挖礦、GameFi、私募、社交等全鏈路 DApp 定制化開發。',
  'services.dapp.f1': '質押 / 挖礦',
  'services.dapp.f2': 'GameFi / NFT',
  'services.dapp.f3': '私募 / 分紅',
  'services.more': '查看詳情',

  'adv.tag': '核心優勢',
  'adv.title': '為什麼選擇我們',
  'adv.subtitle': '8 年+行業深耕，以技術驅動，護航您的 Web3 業務',
  'adv.1.num': '01',
  'adv.1.title': '模塊化架構',
  'adv.1.desc': '高度模塊化的系統設計，各功能模塊獨立部署、自由組合，支持快速迭代與靈活擴展。',
  'adv.2.num': '02',
  'adv.2.title': '完整公鏈生態佈局',
  'adv.2.desc': '深度支持以太坊、BSC、Solana 等主流公鏈，具備完整的跨鏈互操作能力。',
  'adv.3.num': '03',
  'adv.3.title': '創新驅動',
  'adv.3.desc': '持續跟蹤 Web3 前沿技術，將 ZK Proof、Layer2、AI 風控融入產品，保持技術領先。',
  'adv.4.num': '04',
  'adv.4.title': '安全合規',
  'adv.4.desc': '多重安全審計，符合新加坡 MAS、香港 SFC 等主流司法管轄區合規要求。',
  'adv.5.num': '05',
  'adv.5.title': '客戶導向與生態共贏',
  'adv.5.desc': '專屬項目經理、24/7 技術支持，以客戶業務成功為最終目標，攜手共建 Web3 生態。',

  'products.tag': '產品體系',
  'products.title': '完整產品矩陣',
  'products.subtitle': '從諮詢、開發到運維，提供全生命週期一站式支持',
  'products.exchange': '交易所系統',
  'products.rwa': 'RWA 解決方案',
  'products.wallet': '錢包類產品',
  'products.staking': '質押類產品',
  'products.mining': '挖礦類產品',
  'products.more': '查看詳情',

  'news.tag': '新聞動態',
  'news.title': '最新資訊',
  'news.subtitle': '產品迭代 · 行業洞察 · Web3 前沿',
  'news.more': '查看全部',
  'news.read': '閱讀更多',
  'news.product': '產品動態',
  'news.industry': '行業動態',

  'cta.title': '準備開啟您的 Web3 之旅？',
  'cta.subtitle': '專業團隊一對一諮詢，從戰略規劃到技術落地全程陪伴',
  'cta.btn': '立即聯繫我們',
  'cta.btn2': '查看產品案例',
  'cta.badge1': '新加坡註冊企業',
  'cta.badge2': '8 年+經驗',
  'cta.badge3': '24/7 支持',
  'cta.badge4': '原始碼交付',

  'footer.about': '總部位於新加坡的產業區塊鏈與 Web3 全棧解決方案服務商，專注為企業構建可信數字基礎設施。',
  'footer.links': '快速鏈接',
  'footer.products': '產品體系',
  'footer.services': '專業服務',
  'footer.contact': '聯繫我們',
  'footer.address': '160 Robinson Road, #14-04 SBFCenter, Singapore 068914',
  'footer.email': 'info@geelx.com',
  'footer.telegram': 'Telegram: +447849923593',
  'footer.whatsapp': 'WhatsApp: +447849923593',
  'footer.copyright': '© 2026 Geelx.com. All rights reserved.',
  'footer.privacy': '隱私政策',
  'footer.terms': '服務條款',
  'footer.subscribe': '訂閱行業資訊',
  'footer.subscribe.placeholder': '輸入您的郵箱',
  'footer.subscribe.btn': '訂閱',
  'footer.subscribe.success': '訂閱成功！感謝您的關注',
  'footer.rss': 'RSS 訂閱新聞',
  'rss.feedTitle': 'Geelx 新聞動態',
  'rss.subscribe': 'RSS 訂閱',
  'footer.wechat': '微信：請掃描二維碼',
  'footer.badge.security': '安全認證',
  'footer.badge.singapore': '新加坡註冊',
  'footer.badge.experience': '8年+ 經驗',
  'footer.badge.support': '24/7 支持',

  'breadcrumb.home': '首頁',
  'breadcrumb.about': '公司簡介',
  'notFound.title': '頁面不存在',
  'notFound.subtitle': '請檢查連結是否正確，或返回首頁繼續瀏覽。',

  'aboutPage.hero.tag': 'About Us',
  'aboutPage.hero.title': '公司簡介',
  'aboutPage.hero.highlight': '我們是誰',
  'aboutPage.hero.subtitle1': '總部位於新加坡的產業區塊鏈與 Web3 全棧解決方案服務商。',
  'aboutPage.hero.subtitle2': '我們將複雜的區塊鏈技術轉化為企業可落地的生產力，推動實體經濟與 Web3 深度融合。',
  'aboutPage.hero.stats.0.val': '2023',
  'aboutPage.hero.stats.0.label': '年成立',
  'aboutPage.hero.stats.1.val': '新加坡',
  'aboutPage.hero.stats.1.label': '總部所在地',
  'aboutPage.hero.stats.2.val': '8+',
  'aboutPage.hero.stats.2.label': '年行業經驗',
  'aboutPage.hero.stats.3.val': '50+',
  'aboutPage.hero.stats.3.label': '企業客戶',
  'breadcrumb.news': '新聞動態',
  'newsPage.categories.all': '全部動態',
  'newsPage.categories.product': '產品動態',
  'newsPage.categories.industry': '行業動態',
  'newsPage.hero.tag': 'News & Insights',
  'newsPage.hero.title': '新聞動態',
  'newsPage.hero.highlight': '洞察 Web3 前沿',
  'newsPage.hero.desc1': '產品動態、技術深度解析、行業趨勢洞察——',
  'newsPage.hero.desc2': '我們持續為您帶來 Web3 與產業區塊鏈領域最新資訊。',
  'newsPage.hero.stats.articles': '篇文章',
  'newsPage.hero.stats.categories': '內容分類',
  'newsPage.hero.stats.frequency': '月更',
  'newsPage.hero.stats.monthly': '12+ 篇',
  'newsPage.featured.title': '精選文章',
  'newsPage.featured.badge': '精選',
  'newsPage.readSuffix': '閱讀',
  'newsPage.readFull': '閱讀全文',
  'newsPage.grid.empty': '暫無該分類的文章',
  'newsPage.grid.total': '共 {{count}} 篇',
  'newsPage.grid.loadMore': '載入更多文章（剩餘 {{remaining}} 篇）',
  'newsPage.grid.allShown': '已顯示全部 {{count}} 篇文章',
  'newsDetail.readTime': '預計閱讀 {{time}}',
  'newsDetail.share': '分享：',
  'newsDetail.related.title': '相關文章',
  'newsDetail.summary': '文章概要',
  'newsDetail.contactHint': '有業務需求？與我們的專家溝通',
  'newsDetail.contactTeam': '聯繫商務團隊',
  'newsDetail.shareArticle': '分享文章',
  'newsDetail.copyLink': '複製連結',
  'share.linkCopied': '連結已複製',
  'share.native': '更多分享方式',
  'newsDetail.cta.subtitle': '想了解更多 Web3 解決方案？',
  'newsDetail.cta.title': '聯繫我們的專業團隊，獲取定制化方案',
  'newsDetail.backToList': '返回列表',
  'breadcrumb.contact': '聯繫我們',
  'contact.hero.tag': 'Contact Us',
  'contact.hero.title': '聯繫我們',
  'contact.hero.highlight': '開啟合作對話',
  'contact.hero.desc1': '無論您是初創項目還是成熟企業，我們的團隊隨時準備為您提供專業的 Web3 解決方案諮詢服務。',
  'contact.hero.desc2': '填寫表單或直接聯繫我們，通常 24 小時內回覆。',
  'contact.hero.card.0.label': '郵件諮詢',
  'contact.hero.card.0.val': 'info@geelx.com',
  'contact.hero.card.1.label': '7×24 在線支持',
  'contact.hero.card.1.val': '隨時響應',
  'contact.hero.card.2.label': '平均響應時間',
  'contact.hero.card.2.val': '< 4 小時',
  'contact.form.captcha': '驗證碼',
  'contact.form.captcha.placeholder': '請輸入驗證碼',
  'contact.form.captcha.refresh': '換一張',
  'contact.form.error.captcha': '驗證碼錯誤或已過期，請重新輸入',
  'contact.form.error.maxChars': '留言內容不能超過 500 字符',
  'contact.form.success.title': '提交成功！',
  'contact.form.success.desc1': '感謝您的留言，我們的商務團隊將在',
  'contact.form.success.descStrong': '24 小時內',
  'contact.form.success.desc2': '與您取得聯繫。',
  'contact.form.success.desc3': '請留意來自',
  'contact.form.success.desc4': '的郵件。',
  'contact.form.submitAgain': '再次提交',
  'contact.form.title': '發送諮詢',
  'contact.form.subtitle': '請填寫以下信息，我們將盡快與您聯繫',
  'contact.form.name': '姓名',
  'contact.form.name.placeholder': '您的姓名',
  'contact.form.company': '公司名稱',
  'contact.form.company.placeholder': '您的公司（選填）',
  'contact.form.email': '郵件地址',
  'contact.form.phone': '電話 / WhatsApp',
  'contact.form.inquiryType': '諮詢業務',
  'contact.form.inquiryType.placeholder': '請選擇諮詢類型...',
  'contact.form.budget': '預算範圍',
  'contact.form.message': '留言內容',
  'contact.form.message.placeholder': '請簡要描述您的項目需求、當前階段及期望時間線...',
  'contact.form.message.hint': '詳細描述將幫助我們更快匹配方案',
  'contact.form.error.submitFailed': '提交失敗，請稍後重試或直接發送郵件聯繫我們',
  'contact.form.submitting': '提交中...',
  'contact.form.submit': '發送諮詢',
  'contact.form.agreePrefix': '提交即表示您同意我們的',
  'contact.form.and': '及',
  'contact.social': '社交媒體',
  'contact.social.wechat': '微信公眾號',
  'contact.offices.tag': 'Global Offices',
  'contact.offices.title': '全球辦公室佈局',
  'contact.offices.subtitle': '三地協同運營，確保跨時區快速響應，本地化服務全球客戶',
  'contact.faq.tag': 'FAQ',
  'contact.faq.title': '常見問題',
  'contact.faq.highlight': '快速解答',
  'contact.faq.subtitle': '以下是客戶在合作初期最常詢問的問題。如果您有其他疑問，歡迎直接提交表單聯繫我們。',
  'contact.faq.notFound': '沒找到答案？',
  'contact.faq.askExpert': '直接諮詢我們的專家',
  'contact.faq.submitForm': '提交諮詢表單',
  'contact.bottom.title': '準備好開始您的 Web3 項目了嗎？',
  'contact.bottom.subtitle': '立即聯繫我們，獲取免費的項目評估報告與技術方案建議',
  'contact.bottom.emailUs': '發郵件給我們',
  'contact.bottom.submitNow': '立即提交諮詢',
  'contact.inquiry.0': '中心化交易所 (CEX) 開發',
  'contact.inquiry.1': 'RWA 資產代幣化',
  'contact.inquiry.2': 'Web3 錢包開發',
  'contact.inquiry.3': 'DeFi 質押協議',
  'contact.inquiry.4': '礦機託管平台',
  'contact.inquiry.5': '智能合約審計',
  'contact.inquiry.6': '企業區塊鏈定制',
  'contact.inquiry.7': '其他諮詢',
  'contact.info.address': '總部地址',
  'contact.info.email': '商務郵件',
  'contact.info.email.partner': '合作夥伴: partner@geelx.com',
  'contact.info.email.market': '市場部: market@geelx.com',
  'contact.info.phone': 'Telegram/WhatsApp',
  'contact.info.telegram': 'Telegram: +44 7849923593',
  'contact.info.whatsapp': 'WhatsApp: +44 7849923593',
  'contact.info.hours': '工作時間',
  'contact.info.hours.line1': '週一至週五 09:00 – 18:00 SGT',
  'contact.info.hours.line2': '技術支持 7 × 24 小時',
  'contact.office.0.city': '新加坡（總部）',
  'contact.office.1.city': '香港（業務中心）',
  'contact.office.2.city': '上海（研發協作）',
  'contact.office.2.address': '上海市浦東新區陸家嘴金融區某大廈 18F',
  'contact.faq.items.0.q': '從提交需求到正式立項需要多久？',
  'contact.faq.items.0.a': '通常在初次溝通後 3–5 個工作日內完成需求評估，並向您提交初步解決方案與報價。',
  'contact.faq.items.1.q': '你們支持哪些合作模式？',
  'contact.faq.items.1.a': '我們提供固定報價項目制、按月技術外包、戰略技術合夥三種模式。',
  'contact.faq.items.2.q': '是否提供源代碼交付？',
  'contact.faq.items.2.a': '是的，所有項目均包含完整源代碼交付（含開發文檔與部署手冊）。',
  'contact.faq.items.3.q': '能否協助申請監管牌照？',
  'contact.faq.items.3.a': '我們與新加坡 MAS、香港 SFC 等主流轄區持牌律所保持深度合作。',
  'contact.faq.items.4.q': '項目完成後是否有售後支持？',
  'contact.faq.items.4.a': '標準服務包含交付後 3 個月免費維護期，含 24/7 線上支持與 Bug 修復。',
  'contact.faq.items.5.q': '是否接受海外客戶遠程合作？',
  'contact.faq.items.5.a': '完全支持。我們大量客戶來自海外，支持跨時區高效協作。',
  'breadcrumb.products': '產品體系',
  'breadcrumb.services': '服務',

  'serviceDetail.outline': '內容概要',
  'serviceDetail.contactHint': '有業務需求？與我們的專家溝通',
  'serviceDetail.contactTeam': '聯繫商務團隊',
  'serviceDetail.cta.subtitle': '準備好開始了嗎？',
  'serviceDetail.cta.title': '立即與我們的專家聯繫，探討您的需求',
  'serviceDetail.backToList': '返回服務列表',
  'productsPage.hero.tag': 'Product Suite',
  'productsPage.hero.title': '產品體系',
  'productsPage.hero.highlight': '全棧 Web3 解決方案',
  'productsPage.hero.desc1': '五大產品線覆蓋交易所、資產管理、去中心化錢包、質押與挖礦全場景，',
  'productsPage.hero.desc2': '提供從諮詢規劃到開發交付再到持續運維的全生命週期服務。',
  'productsPage.hero.chip.cex': '中心化交易所',
  'productsPage.hero.chip.rwa': 'RWA 解決方案',
  'productsPage.hero.chip.wallet': '錢包生態',
  'productsPage.hero.chip.defi': 'DeFi 質押',
  'productsPage.hero.chip.mining': '挖礦平台',
  'productsOverview.tag': 'Product Lines',
  'productsOverview.title': '四大核心產品線',
  'productsOverview.desc1': '從交易基礎設施到資產管理，覆蓋 Web3 企業全場景需求，',
  'productsOverview.desc2': '全生命週期服務：諮詢 -> 開發 -> 運維',
  'productsOverview.cta': '查看詳細方案',
  'productsOverview.lines.cex.label': '中心化交易所 CEX',
  'productsOverview.lines.cex.desc': '全棧 CEX 解決方案，覆蓋標準版、集群版、大客戶定制版，支持高性能訂單撮合引擎與多端覆蓋。',
  'productsOverview.lines.cex.tags.0': '標準單體',
  'productsOverview.lines.cex.tags.1': '集群版',
  'productsOverview.lines.cex.tags.2': '大客戶定制',
  'productsOverview.lines.cex.tags.3': 'PC / H5',
  'productsOverview.lines.cex.stats.0': 'TPS',
  'productsOverview.lines.cex.stats.1': 'SLA',
  'productsOverview.lines.wallet.label': '錢包 + IM 生態',
  'productsOverview.lines.wallet.desc': 'Web3 去中心化錢包 App、錢包+IM 社交融合、網頁版全平台覆蓋，80+ 條公鏈一站式管理。',
  'productsOverview.lines.wallet.tags.0': 'App 錢包',
  'productsOverview.lines.wallet.tags.1': '錢包+IM',
  'productsOverview.lines.wallet.tags.2': '網頁版',
  'productsOverview.lines.wallet.stats.0': '條公鏈',
  'productsOverview.lines.wallet.stats.1': '端覆蓋',
  'productsOverview.lines.rwa.label': 'RWA 資產上鏈',
  'productsOverview.lines.rwa.desc': '房地產、藝術品、供應鏈、私募股權等真實資產上鏈，法律合規+技術可信+金融流通三層架構。',
  'productsOverview.lines.rwa.tags.0': '房地產',
  'productsOverview.lines.rwa.tags.1': '藝術品',
  'productsOverview.lines.rwa.tags.2': '供應鏈',
  'productsOverview.lines.rwa.tags.3': '私募股權',
  'productsOverview.lines.rwa.stats.0': '層架構',
  'productsOverview.lines.rwa.stats.1': '司法轄區',
  'productsOverview.lines.dapp.label': 'DeFi 質押 & 雲礦機',
  'productsOverview.lines.dapp.desc': '質押系統、挖礦平台、NFT 市場、遊戲 DApp、私募平台等全品類定制開發，源碼交付。',
  'productsOverview.lines.dapp.tags.0': '質押系統',
  'productsOverview.lines.dapp.tags.1': '挖礦平台',
  'productsOverview.lines.dapp.tags.2': 'NFT',
  'productsOverview.lines.dapp.tags.3': '遊戲 DApp',
  'productsOverview.lines.dapp.stats.0': '交付',
  'productsOverview.lines.dapp.stats.1': '支持',
  'productsLifecycle.quick.title': '五大產品線，快速直達',
  'productsLifecycle.quick.subtitle': '選擇您感興趣的產品類別，查看完整技術方案',
  'productsLifecycle.tag': 'Full Lifecycle',
  'productsLifecycle.title': '全生命週期服務',
  'productsLifecycle.desc': '從初始諮詢到持續運維，每個階段都有專業團隊保障，讓您的 Web3 項目從想法到商業化無縫落地',
  'productsLifecycle.stepPrefix': 'STEP',
  'productsLifecycle.steps.0.title': '需求諮詢',
  'productsLifecycle.steps.0.desc': '業務分析與技術選型建議，輸出完整方案文檔與報價',
  'productsLifecycle.steps.0.duration': '3-5 個工作日',
  'productsLifecycle.steps.1.title': '架構設計',
  'productsLifecycle.steps.1.desc': '系統架構規劃、技術棧確定、UI/UX 原型評審',
  'productsLifecycle.steps.1.duration': '1-2 週',
  'productsLifecycle.steps.2.title': '開發交付',
  'productsLifecycle.steps.2.desc': '敏捷迭代開發，專屬項目經理全程跟進，階段性驗收',
  'productsLifecycle.steps.2.duration': '4-16 週',
  'productsLifecycle.steps.3.title': '安全審計',
  'productsLifecycle.steps.3.desc': '智能合約審計、滲透測試、代碼質量評審，確保上線安全',
  'productsLifecycle.steps.3.duration': '1-2 週',
  'productsLifecycle.steps.4.title': '上線部署',
  'productsLifecycle.steps.4.desc': '生產環境部署、壓力測試、灰度發布與上線監控',
  'productsLifecycle.steps.4.duration': '3-7 天',
  'productsLifecycle.steps.5.title': '持續運維',
  'productsLifecycle.steps.5.desc': '7×24 技術支持、系統監控、版本迭代與功能升級',
  'productsLifecycle.steps.5.duration': '持續服務',
  'productsLifecycle.cta.start': '立即開始諮詢',
  'productsLifecycle.cta.learn': '了解服務保障',
  'productsDetail.cex.breadcrumb': '中心化交易所',
  'productsDetail.cex.title': '中心化交易所',
  'productsDetail.cex.highlight': '全棧一站式方案',
  'productsDetail.cex.cta': '獲取方案報價',
  'productsDetail.cex.desc1': '從標準單體架構到企業級集群部署，從大客戶定制到 PC/H5 全端覆蓋，',
  'productsDetail.cex.desc2': '提供高性能訂單撮合引擎、KYC/AML 合規模塊及完整運維體系，',
  'productsDetail.cex.desc3': '助您快速上線並安全規模化運營。',
  'productsDetail.cex.tags.0': '100K+ TPS 撮合',
  'productsDetail.cex.tags.1': 'KYC/AML 合規',
  'productsDetail.cex.tags.2': 'PC / H5 / APP',
  'productsDetail.cex.tags.3': '7×24 運維保障',
  'productsDetail.cex.stats.0.label': '峰值撮合性能',
  'productsDetail.cex.stats.1.label': '系統可用性保障',
  'productsDetail.cex.stats.2.label': '訂單響應延遲',
  'productsDetail.cex.stats.3.unit': '家',
  'productsDetail.cex.stats.3.label': '全球成功上線案例',
  'productsDetail.cex.tabs.standard': '標準單體架構',
  'productsDetail.cex.tabs.cluster': '集群版',
  'productsDetail.cex.tabs.custom': '大客戶定制版',
  'productsDetail.cex.tabs.pc': 'PC 端',
  'productsDetail.cex.tabs.h5': 'H5 移動端',
  'productsDetail.rwa.breadcrumb': 'RWA 資產代幣化',
  'productsDetail.rwa.title': 'RWA 資產代幣化',
  'productsDetail.rwa.highlight': '鏈上合規發行平台',
  'productsDetail.rwa.cta': '獲取合規方案報價',
  'productsDetail.rwa.desc1': '將現實世界資產（房產、股權、債券、大宗商品）映射至區塊鏈，',
  'productsDetail.rwa.desc2': '構建符合主流司法轄區監管要求的數字證券發行、流通與清結算全生命週期平台，',
  'productsDetail.rwa.desc3': '打通傳統金融與 Web3 流動性。',
  'productsDetail.rwa.tags.0': '多轄區合規',
  'productsDetail.rwa.tags.1': 'STO 標準',
  'productsDetail.rwa.tags.2': '二級流通市場',
  'productsDetail.rwa.tags.3': '智能合約審計',
  'productsDetail.rwa.stats.0.unit': '類',
  'productsDetail.rwa.stats.0.label': '支持資產種類',
  'productsDetail.rwa.stats.1.label': '累計代幣化規模',
  'productsDetail.rwa.stats.2.unit': '轄區',
  'productsDetail.rwa.stats.2.label': '合規覆蓋範圍',
  'productsDetail.rwa.stats.3.unit': '項目',
  'productsDetail.rwa.stats.3.label': '全球成功發行案例',
  'productsDetail.rwa.tabs.compliance': '合規框架',
  'productsDetail.rwa.tabs.architecture': '技術架構',
  'productsDetail.rwa.tabs.assetTypes': '資產類型',
  'productsDetail.rwa.tabs.issuance': '發行流程',
  'productsDetail.rwa.tabs.market': '二級市場',
  'productsDetail.wallet.breadcrumb': 'Web3 錢包',
  'productsDetail.wallet.title': 'Web3 多鏈錢包',
  'productsDetail.wallet.highlight': '一體化資產管理門戶',
  'productsDetail.wallet.cta': '獲取錢包方案',
  'productsDetail.wallet.desc1': '支持 100+ 主流公鏈，集 MPC 多方計算安全、DApp 內置瀏覽器、',
  'productsDetail.wallet.desc2': '跨鏈兌換與企業級資產託管於一體，',
  'productsDetail.wallet.desc3': '為 C 端用戶與機構客戶提供專業級 Web3 入口。',
  'productsDetail.wallet.tags.0': '100+ 公鏈',
  'productsDetail.wallet.tags.1': 'MPC 安全',
  'productsDetail.wallet.tags.2': 'DApp 瀏覽器',
  'productsDetail.wallet.tags.3': '跨鏈兌換',
  'productsDetail.wallet.stats.0.unit': '條',
  'productsDetail.wallet.stats.0.label': '支持公鏈數量',
  'productsDetail.wallet.stats.1.unit': '用戶',
  'productsDetail.wallet.stats.1.label': '全球活躍用戶',
  'productsDetail.wallet.stats.2.unit': '個',
  'productsDetail.wallet.stats.2.label': '集成 DApp 數量',
  'productsDetail.wallet.stats.3.unit': '次',
  'productsDetail.wallet.stats.3.label': '安全漏洞記錄',
  'productsDetail.wallet.tabs.multichain': '多鏈支持',
  'productsDetail.wallet.tabs.security': '安全體系',
  'productsDetail.wallet.tabs.dapp': 'DApp 生態',
  'productsDetail.wallet.tabs.enterprise': '企業錢包',
  'productsDetail.wallet.tabs.sdk': '開發者 SDK',
  'productsDetail.defi.breadcrumb': 'DeFi 質押協議',
  'productsDetail.defi.title': 'DeFi 質押協議',
  'productsDetail.defi.highlight': '高收益流動性全棧方案',
  'productsDetail.defi.cta': '獲取 DeFi 方案',
  'productsDetail.defi.desc1': '從 PoS 質押、AMM 流動性挖礦到收益聚合器，再到跨鏈橋與 DAO 治理，',
  'productsDetail.defi.desc2': '提供完整的 DeFi 協議開發與部署服務，',
  'productsDetail.defi.desc3': '讓用戶資產持續增值，平台流動性深度持續擴展。',
  'productsDetail.defi.tags.0': 'PoS 質押',
  'productsDetail.defi.tags.1': 'AMM 流動性',
  'productsDetail.defi.tags.2': '收益聚合',
  'productsDetail.defi.tags.3': '跨鏈橋',
  'productsDetail.defi.stats.0.label': '平台鎖倉總價值 TVL',
  'productsDetail.defi.stats.1.label': '最高年化收益率',
  'productsDetail.defi.stats.2.unit': '協議',
  'productsDetail.defi.stats.2.label': '已部署 DeFi 協議數',
  'productsDetail.defi.stats.3.unit': '對',
  'productsDetail.defi.stats.3.label': '支持交易對數量',
  'productsDetail.defi.tabs.protocol': '質押協議',
  'productsDetail.defi.tabs.liquidity': '流動性挖礦',
  'productsDetail.defi.tabs.aggregator': '收益聚合',
  'productsDetail.defi.tabs.bridge': '跨鏈橋',
  'productsDetail.defi.tabs.governance': '治理投票',
  'productsDetail.mining.breadcrumb': '雲礦機',
  'productsDetail.mining.title': '雲礦機平台',
  'productsDetail.mining.highlight': '算力即服務，隨時挖礦',
  'productsDetail.mining.cta': '獲取雲礦機方案',
  'productsDetail.mining.desc1': '提供 BTC/ETH/LTC 等主流幣種雲算力租賃平台一站式搭建，',
  'productsDetail.mining.desc2': '覆蓋算力套餐管理、礦池接入、收益自動結算與機房託管系統，',
  'productsDetail.mining.desc3': '讓任何人都能輕鬆參與加密貨幣挖礦。',
  'productsDetail.mining.tags.0': '算力租賃',
  'productsDetail.mining.tags.1': '礦池系統',
  'productsDetail.mining.tags.2': '自動結算',
  'productsDetail.mining.tags.3': '機房託管',
  'productsDetail.mining.stats.0.label': '平台總算力規模',
  'productsDetail.mining.stats.1.label': '礦機在線率保障',
  'productsDetail.mining.stats.2.unit': '大',
  'productsDetail.mining.stats.2.label': '全球機房節點',
  'productsDetail.mining.stats.3.label': '超低能耗比',
  'productsDetail.mining.tabs.hashrate': '算力套餐',
  'productsDetail.mining.tabs.infrastructure': '機房基礎設施',
  'productsDetail.mining.tabs.pool': '礦池系統',
  'productsDetail.mining.tabs.earnings': '收益結算',
  'productsDetail.mining.tabs.colocation': '託管方案',
  'productsCta.back': '返回產品總覽',
  'productsCta.cex.tag': 'Ready to Launch?',
  'productsCta.cex.title': '準備好啟動您的交易所了嗎？',
  'productsCta.cex.desc1': '從需求溝通到交付上線，我們的專業團隊全程陪同，',
  'productsCta.cex.desc2': '最快 4 週完成標準版部署，附贈完整源碼與運維手冊。',
  'productsCta.cex.quote': '獲取完整方案報價',
  'productsCta.cex.badge.0': '源碼完整交付',
  'productsCta.cex.badge.1': '安全審計通過',
  'productsCta.cex.badge.2': '7×24 技術支持',
  'productsCta.cex.badge.3': '合規文件齊全',
  'productsCta.rwa.tag': 'Ready to Tokenize?',
  'productsCta.rwa.title': '準備好代幣化您的資產了嗎？',
  'productsCta.rwa.desc1': '從法律架構設計到智能合約部署，再到二級市場上架，',
  'productsCta.rwa.desc2': '我們的專業團隊全程陪同，10-18 週完成完整發行流程。',
  'productsCta.rwa.quote': '獲取 RWA 方案報價',
  'productsCta.rwa.badge.0': '合規資質認證',
  'productsCta.rwa.badge.1': '智能合約審計',
  'productsCta.rwa.badge.2': '15+ 司法轄區',
  'productsCta.rwa.badge.3': '法律文件齊全',
  'productsCta.wallet.tag': 'Launch Your Wallet',
  'productsCta.wallet.title': '打造專屬的 Web3 錢包品牌',
  'productsCta.wallet.desc1': '從白標 SDK 集成到完整定制開發，最快 2 週完成品牌化錢包上線，',
  'productsCta.wallet.desc2': '完整源碼交付，App Store 上架輔助。',
  'productsCta.wallet.quote': '獲取錢包方案報價',
  'productsCta.wallet.badge.0': '100+ 公鏈支持',
  'productsCta.wallet.badge.1': '頂級安全審計',
  'productsCta.wallet.badge.2': '完整 SDK 交付',
  'productsCta.wallet.badge.3': '500+ DApp 生態',
  'productsCta.defi.tag': 'Launch Your DeFi Protocol',
  'productsCta.defi.title': '構建您的 DeFi 收益生態',
  'productsCta.defi.desc1': '從質押協議、AMM 流動性到跨鏈橋與 DAO 治理，',
  'productsCta.defi.desc2': '我們提供經過安全審計的完整 DeFi 協議棧，助您快速搭建並運營高 TVL 平台。',
  'productsCta.defi.quote': '獲取 DeFi 方案報價',
  'productsCta.defi.badge.0': '智能合約三方審計',
  'productsCta.defi.badge.1': '四種質押模式',
  'productsCta.defi.badge.2': '40+ 鏈跨鏈橋',
  'productsCta.defi.badge.3': 'DAO 治理投票',
  'productsCta.mining.tag': 'Start Mining Today',
  'productsCta.mining.title': '搭建您的雲礦機平台',
  'productsCta.mining.desc1': '從算力套餐到礦池系統，從機房基礎設施到收益結算，',
  'productsCta.mining.desc2': '我們提供完整的雲礦機平台一站式解決方案，',
  'productsCta.mining.desc3': '支持白標品牌定制，最快 6 週完成上線。',
  'productsCta.mining.quote': '獲取雲礦機方案報價',
  'productsCta.mining.badge.0': '100 EH/s+ 算力',
  'productsCta.mining.badge.1': '全球 5 大機房',
  'productsCta.mining.badge.2': '100% 清潔能源',
  'productsCta.mining.badge.3': '每日自動結算',
  'breadcrumb.advantages': '核心優勢',
  'advantages.hero.tag': 'Core Advantages',
  'advantages.hero.title': '核心優勢',
  'advantages.hero.highlight': '為什麼選擇我們',
  'advantages.hero.desc1': '8 年+行業積澱，五大核心優勢構成難以複製的技術與服務壁壘，',
  'advantages.hero.desc2': '護航您的 Web3 業務從啟動到規模化全程無憂。',
  'advantages.hero.pill.0': '模塊化架構',
  'advantages.hero.pill.1': '公链生态',
  'advantages.hero.pill.2': '創新驅動',
  'advantages.hero.pill.3': '安全合規',
  'advantages.hero.pill.4': '客戶導向',
  'advantages.s1.tag1': '模塊化架構',
  'advantages.s1.title1': '高度模塊化，',
  'advantages.s1.title1h': '靈活組合擴展',
  'advantages.s1.desc1': '我們的全棧解決方案基於微服務 + 模塊化架構設計，各功能模塊獨立封裝、自由組合。',
  'advantages.s1.desc2': '無論您需要一套完整的 CEX 系統，還是只需要特定的撮合引擎或 KYC 模塊，都可以按需選配，',
  'advantages.s1.desc3': '大幅降低初期投入成本，並在業務增長時無縫擴展。',
  'advantages.s1.p1.0': '各功能模塊獨立部署，單模塊故障不影響整體',
  'advantages.s1.p1.1': '按需組合：可單獨採購 CEX 引擎或完整套件',
  'advantages.s1.p1.2': '支持熱更新與灰度發布，業務零中斷升級',
  'advantages.s1.p1.3': '標準化 API 接口，輕鬆對接第三方系統',
  'advantages.s1.p1.4': '微服務架構，水平擴展輕鬆應對業務爆發',
  'advantages.s1.stat1': '模塊復用率',
  'advantages.s1.stat2': '迭代速度提升',
  'advantages.s1.stat3': '運維成本降低',
  'advantages.s1.badge1': '模塊化架構',
  'advantages.s1.badge1d': '按需組裝 · 獨立部署',
  'advantages.s1.badge2': '多鏈互操作',
  'advantages.s1.badge2d': '15+ 主流公鏈支持',
  'advantages.s1.tag2': '完整公鏈生態佈局',
  'advantages.s1.title2': '多鏈並行，',
  'advantages.s1.title2h': '全生態覆蓋',
  'advantages.s1.desc4': '我們深度支持 15+ 主流公鏈，具備完整的跨鏈互操作能力。',
  'advantages.s1.desc5': '無論您的業務運行在以太坊的 DeFi 生態，還是 Solana 的高頻交易場景，',
  'advantages.s1.desc6': '抑或波場的穩定幣支付場景，我們都有成熟的解決方案和實戰案例支撐。',
  'advantages.s1.p2.0': 'ETH、BSC、Solana、波場等主流公鏈深度支持',
  'advantages.s1.p2.1': '跨鏈橋接協議，實現多鏈資產無縫互通',
  'advantages.s1.p2.2': 'Layer 2 集成（Arbitrum、Optimism、ZK-Rollup）',
  'advantages.s1.p2.3': '聯盟鏈+公鏈混合架構，兼顧合規與去中心化',
  'advantages.s1.p2.4': '多鏈錢包統一管理，降低用戶操作門檻',
  'advantages.s2.tag1': '創新驅動',
  'advantages.s2.title1': '技術前沿，',
  'advantages.s2.title1h': '持續創新領跑',
  'advantages.s2.desc1': '我們保持對 Web3 前沿技術的持續追蹤與研究投入，將 ZK Proof、Layer2、AI 風控等創新能力',
  'advantages.s2.desc2': '系統性融入產品體系，確保客戶使用的技術始終處於行業領先水平，而非追趕者角色。',
  'advantages.s2.inno.0.t': 'ZK Proof 應用',
  'advantages.s2.inno.0.d': '零知識證明技術，在保護用戶隱私的同時實現合規驗證，兼顧安全與體驗。',
  'advantages.s2.inno.1.t': 'Layer 2 優化',
  'advantages.s2.inno.1.d': '深度集成 Arbitrum、Optimism、ZK-Rollup，Gas 成本降低 90%+，TPS 大幅提升。',
  'advantages.s2.inno.2.t': 'AI 智能風控',
  'advantages.s2.inno.2.d': '將機器學習模型嵌入風控引擎，實時識別異常交易行為，誤報率低於 0.1%。',
  'advantages.s2.inno.3.t': 'NFT 基礎設施',
  'advantages.s2.inno.3.d': '完整的 NFT 鑄造、交易、碎片化和質押系統，支持 ERC-721/1155 等標準。',
  'advantages.s2.rd': '研發投入',
  'advantages.s2.rd1': '年收入投入研發',
  'advantages.s2.rd2': '核心技術專利',
  'advantages.s2.rd3': '技術工程師',
  'advantages.s2.badge': '多重安全保障',
  'advantages.s2.badged': '零致命漏洞上線承諾',
  'advantages.s2.tag2': '安全合規',
  'advantages.s2.title2': '安全第一，',
  'advantages.s2.title2h': '全球合規覆蓋',
  'advantages.s2.desc3': '區塊鏈行業安全事故頻發，合規要求日趨嚴格。我們建立了業內領先的多層安全審計體系，',
  'advantages.s2.desc4': '同時深度研究全球主要司法轄區的合規框架，幫助客戶在安全合規的軌道上穩健經營。',
  'advantages.s2.compTitle': '覆蓋司法轄區',
  'advantages.s2.comp.0.r': '新加坡',
  'advantages.s2.comp.0.d': '支付服務法案 (PSA) 合規框架，數字支付代幣服務牌照輔導',
  'advantages.s2.comp.1.r': '香港',
  'advantages.s2.comp.1.d': '虛擬資產服務提供商 (VASP) 牌照框架，證券型代幣合規發行',
  'advantages.s2.comp.2.r': '欧盟',
  'advantages.s2.comp.2.d': 'Markets in Crypto-Assets 法規合規評估與系統適配',
  'advantages.s2.comp.3.r': '美国',
  'advantages.s2.comp.3.d': 'AML/KYC 反洗錢合規體系搭建，MSB 牌照申請支持',
  'advantages.s2.comp.4.r': '开曼群岛',
  'advantages.s2.comp.4.d': '離岸基金與 DeFi 協議的合規架構設計',
  'advantages.s2.comp.5.r': '英属维京岛',
  'advantages.s2.comp.5.d': 'Web3 項目離岸公司註冊與合規運營支持',
  'advantages.s3.tag': '客戶導向與生態共贏',
  'advantages.s3.title1': '以客戶成功為',
  'advantages.s3.title2': '唯一目標',
  'advantages.s3.desc1': '我們不只是技術供應商，而是您的長期戰略技術夥伴。',
  'advantages.s3.desc2': '每一個合作客戶的成功，都是我們最有價值的品牌證明。',
  'advantages.s3.benefit.0.title': '專屬項目經理',
  'advantages.s3.benefit.0.desc': '每個項目配備 1 名專屬 PM，全程跟進需求、進度、上線，統一溝通窗口，高效決策。',
  'advantages.s3.benefit.1.title': '30 分鐘響應承諾',
  'advantages.s3.benefit.1.desc': '關鍵系統問題 30 分鐘內響應，生產故障 2 小時內修復，SLA 寫入合同具法律約束力。',
  'advantages.s3.benefit.2.title': '生態資源對接',
  'advantages.s3.benefit.2.desc': '為客戶引薦律所、做市商、交易所、媒體資源，幫助業務快速獲取生態合作機會。',
  'advantages.s3.benefit.3.title': '以客戶成功為目標',
  'advantages.s3.benefit.3.desc': '我們的成功與客戶業務成功深度綁定。客戶成功案例，才是我們最有價值的品牌資產。',
  'advantages.s3.compareTitle': '與行業同類對比',
  'advantages.s3.compareCol.0': '能力對比',
  'advantages.s3.compareCol.1': '我们',
  'advantages.s3.compareCol.2': '一般供应商',
  'advantages.s3.compare.0': '模塊化架構',
  'advantages.s3.compare.1': '15+ 公链支持',
  'advantages.s3.compare.2': 'ZK/Layer2 集成',
  'advantages.s3.compare.3': '全球合規覆蓋',
  'advantages.s3.compare.4': '專屬項目經理',
  'advantages.s3.compare.5': '源碼完整交付',
  'advantages.s3.compare.6': '24/7 技术支持',
  'advantages.s3.compare.7': '生態資源對接',
  'advantages.s3.cta.title': '準備好了嗎？',
  'advantages.s3.cta.desc': '我們是您 Web3 業務最可靠的技術夥伴',
  'advantages.s3.cta.btn2': '瀏覽產品體系',
  'aboutPage.mission.badge': '新加坡註冊成立',
  'aboutPage.mission.cardTitle': '我們的使命',
  'aboutPage.mission.cardDesc1': '將複雜的區塊鏈技術轉化為企業可落地的生產力，',
  'aboutPage.mission.cardDesc2': '讓 Web3 真正服務於實體經濟發展。',
  'aboutPage.mission.tag': '起源與使命',
  'aboutPage.mission.title1': '誕生於',
  'aboutPage.mission.title2': '區塊鏈黎明',
  'aboutPage.mission.p1': '2023 年，創始團隊在新加坡註冊成立公司，彼時區塊鏈技術剛剛萌芽。我們堅信，這項技術將徹底重塑全球金融體系與實體經濟的運作方式。',
  'aboutPage.mission.p2': '我們見證了從比特幣到以太坊智能合約，從 DeFi 到 NFT，再到 RWA 資產代幣化的完整演進週期。每一個技術浪潮，我們都深入其中，積累了無可替代的實戰經驗。',
  'aboutPage.mission.p3.prefix': '我們的使命始終如一：',
  'aboutPage.mission.p3.strong': '將複雜的區塊鏈技術轉化為企業可落地的生產力',
  'aboutPage.mission.p3.suffix': '，讓每一家有志於 Web3 轉型的企業都能獲得專業、高效、安全的技術支撐。',
  'aboutPage.mission.timeline.0.year': '2023',
  'aboutPage.mission.timeline.0.event': '創始團隊進軍區塊鏈領域，潛心研究相關工作',
  'aboutPage.mission.timeline.1.year': '2024',
  'aboutPage.mission.timeline.1.event': '推出首個 CEX 全棧解決方案',
  'aboutPage.mission.timeline.2.year': '2025',
  'aboutPage.mission.timeline.2.event': 'DeFi 浪潮中全面佈局 DApp、錢包與 IM 產品線',
  'aboutPage.mission.timeline.3.year': '2025',
  'aboutPage.mission.timeline.3.event': 'RWA 解決方案正式發布，開拓實物資產代幣化賽道，並在新加坡註冊成立公司',
  'aboutPage.mission.timeline.4.year': '2026',
  'aboutPage.mission.timeline.4.event': '服務全球企業客戶，成為 Web3 全棧標桿服務商',
  'aboutPage.values.tag': '核心價值與差異化',
  'aboutPage.values.title': '我們的核心價值觀',
  'aboutPage.values.subtitle': '八年專注，三大價值觀貫穿我們的每一個產品決策與服務行為',
  'aboutPage.values.v0.title': '技術即服務',
  'aboutPage.values.v0.subtitle': 'Technology as a Service',
  'aboutPage.values.v0.desc': '我們不只是外包供應商，而是客戶真正的技術夥伴。從戰略規劃到落地實施，全程深度參與，以客戶業務成功為唯一目標。',
  'aboutPage.values.v0.f0': '專屬技術顧問',
  'aboutPage.values.v0.f1': '深度業務理解',
  'aboutPage.values.v0.f2': '長期合作夥伴',
  'aboutPage.values.v1.title': '產業 + Web3 融合',
  'aboutPage.values.v1.subtitle': 'Industry × Web3 Integration',
  'aboutPage.values.v1.desc': '我們專注於將傳統產業與 Web3 深度結合，而非純粹的加密概念炒作。每一個解決方案都以真實業務場景為出發點，確保技術創造實際價值。',
  'aboutPage.values.v1.f0': '實物資產代幣化',
  'aboutPage.values.v1.f1': '供應鏈金融上鏈',
  'aboutPage.values.v1.f2': '合規數字資產發行',
  'aboutPage.values.v2.title': '全生命週期支持',
  'aboutPage.values.v2.subtitle': 'Full Lifecycle Support',
  'aboutPage.values.v2.desc': '從戰略諮詢、架構設計、系統開發、部署上線，到持續運維與迭代升級，我們提供端到端的全鏈路支持，確保客戶零後顧之憂。',
  'aboutPage.values.v2.f0': '諮詢 → 開發 → 運維',
  'aboutPage.values.v2.f1': '源碼完整交付',
  'aboutPage.values.v2.f2': '售後保障體系',
  'aboutPage.values.diffTitle': '與眾不同之處',
  'aboutPage.values.d0.title': '全棧產品矩陣',
  'aboutPage.values.d0.desc': 'CEX + RWA + 錢包 + DApp，任何 Web3 業務場景都有完整產品支撐',
  'aboutPage.values.d1.title': '多司法轄區合規',
  'aboutPage.values.d1.desc': '深度理解新加坡 MAS、香港 SFC 等主流合規框架，確保合法合規運營',
  'aboutPage.values.d2.title': '模塊化靈活組合',
  'aboutPage.values.d2.desc': '各產品模塊獨立部署、自由組合，按需定制，快速響應業務變化',
  'aboutPage.values.d3.title': '24/7 專屬支持',
  'aboutPage.values.d3.desc': '專屬項目經理 + 全天候技術團隊，任何問題 30 分鐘內響應',
  'aboutPage.commit.tag': '承諾與保障',
  'aboutPage.commit.title': '我們的服務承諾',
  'aboutPage.commit.subtitle': '言出必行，每一條承諾都寫入合同，以法律約束力保障您的權益',
  'aboutPage.commit.c0.title': '源碼完整交付',
  'aboutPage.commit.c0.desc': '所有定制開發項目均提供完整源碼，客戶完全掌控技術資產，無任何鎖定風險。',
  'aboutPage.commit.c1.title': '多重安全審計',
  'aboutPage.commit.c1.desc': '專業安全團隊全程介入，代碼審計、漏洞掃描、滲透測試，確保系統零致命漏洞上線。',
  'aboutPage.commit.c2.title': '專屬項目經理',
  'aboutPage.commit.c2.desc': '每個項目配備專屬 PM，全程跟進需求、進度、質量，您只需要做決策，我們負責執行。',
  'aboutPage.commit.c3.title': '24/7 技術支持',
  'aboutPage.commit.c3.desc': '技術團隊全天候待命，關鍵問題 30 分鐘響應，確保您的業務永不中斷。',
  'aboutPage.commit.c4.title': '發票合規開具',
  'aboutPage.commit.c4.desc': '新加坡註冊企業，可按需開具合規發票，支持多種付款方式，滿足不同企業財務需求。',
  'aboutPage.commit.c5.title': '持續迭代升級',
  'aboutPage.commit.c5.desc': '項目交付不是終點。我們提供長期維護合約，隨業務發展持續升級迭代，保持系統長期競爭力。',
  'aboutPage.future.tag': '展望未來',
  'aboutPage.future.title1': '成為全球領先的',
  'aboutPage.future.title2': '產業區塊鏈服務商',
  'aboutPage.future.desc1': '未來五年，我們將持續深耕 RWA 實物資產代幣化賽道，推動更多傳統產業完成 Web3 轉型。',
  'aboutPage.future.desc2': '在全球合規化浪潮中，幫助客戶搶佔先機，共同構建更公平、更透明、更高效的數字經濟基礎設施。',
  'aboutPage.future.btn1': '立即開始合作',
  'aboutPage.future.btn2': '查看核心優勢',

  'seo.brand': 'GEEL TEC',
  'seo.home.title': '產業區塊鏈與 Web3 全棧解決方案 | GEEL TEC',
  'seo.home.desc':
    '新加坡總部，提供 CEX、RWA、數位錢包與 DApp 定制等企業級區塊鏈與 Web3 解決方案。',
  'seo.home.keywords':
    'GEEL TEC, 產業區塊鏈, Web3, 企業數位轉型, 區塊鏈解決方案, 新加坡, CEX, RWA, 數位錢包, DApp, 智能合約',
  'seo.about.title': '公司簡介',
  'seo.about.desc':
    '總部位於新加坡的產業區塊鏈與 Web3 科技公司，專注全棧解決方案、合規諮詢與全球交付。',
  'seo.about.keywords': 'GEEL TEC, 公司簡介, 新加坡公司, 區塊鏈公司, Web3 諮詢, 合規, 企業區塊鏈',
  'seo.advantages.title': '核心優勢',
  'seo.advantages.desc': '模塊化架構、多鏈生態、安全合規與 24/7 支持，助力企業穩妥落地 Web3 業務。',
  'seo.advantages.keywords': 'GEEL TEC, 核心優勢, 模塊化架構, 多鏈, 安全合規, 7x24 支持, Web3 落地',
  'seo.products.title': '產品體系',
  'seo.products.desc': 'CEX、RWA、錢包、DeFi/DApp 與挖礦等模塊化產品，可按需組合、快速上線。',
  'seo.products.keywords': 'GEEL TEC, 產品體系, CEX, RWA, 錢包, DeFi, DApp, 挖礦, 區塊鏈產品',
  'seo.products.cex.title': '中心化交易所 CEX',
  'seo.products.cex.desc': '高性能撮合、KYC/AML、多端交易所系統開發與運維一體化方案。',
  'seo.products.cex.keywords': 'GEEL TEC, CEX, 中心化交易所, 撮合引擎, KYC, AML, 交易所開發',
  'seo.products.rwa.title': 'RWA 解決方案',
  'seo.products.rwa.desc': '實物資產代幣化、合規確權與鏈上分紅，連接傳統金融與鏈上流動性。',
  'seo.products.rwa.keywords': 'GEEL TEC, RWA, 實物資產代幣化, 資產上鏈, 合規代幣化, 數位資產',
  'seo.products.wallet.title': '錢包類產品',
  'seo.products.wallet.desc': '多鏈錢包、DApp 瀏覽器與社交能力，支持企業白標與深度定制。',
  'seo.products.wallet.keywords': 'GEEL TEC, 數位錢包, 多鏈錢包, DApp 瀏覽器, 白標錢包, Web3 錢包',
  'seo.products.defi.title': 'DeFi 與質押',
  'seo.products.defi.desc': '質押、流動性挖礦與鏈上激勵等 DeFi 模塊，安全可審計、可彈性擴展。',
  'seo.products.defi.keywords': 'GEEL TEC, DeFi, 質押, 流動性挖礦, 鏈上激勵, 智能合約, DApp 開發',
  'seo.products.mining.title': '挖礦類產品',
  'seo.products.mining.desc': '礦池、算力與收益體系相關技術方案，面向機構與企業級部署。',
  'seo.products.mining.keywords': 'GEEL TEC, 挖礦, 礦池, 算力, 機構挖礦, 區塊鏈基礎設施',
  'seo.news.title': '新聞動態',
  'seo.news.desc': '產品更新、行業洞察與活動資訊，了解 GEEL TEC 在區塊鏈領域的最新進展。',
  'seo.news.keywords': 'GEEL TEC, 新聞, 區塊鏈資訊, Web3 動態, 產品更新, 行業洞察',
  'seo.newsDetail.title': '新聞詳情',
  'seo.newsDetail.desc': '閱讀 GEEL TEC 新聞與深度文章，獲取 Web3 與企業區塊鏈實踐洞察。',
  'seo.newsDetail.keywords': 'GEEL TEC, 新聞詳情, 區塊鏈文章, Web3, 深度稿',
  'seo.contact.title': '聯繫我們',
  'seo.contact.desc': '業務諮詢、技術合作與合規路徑溝通，聯繫 GEEL TEC 專業團隊獲取方案建議。',
  'seo.contact.keywords': 'GEEL TEC, 聯繫我們, 商務諮詢, 技術支持, 合規諮詢, Web3 合作',
  'seo.notFound.title': '頁面未找到',
  'seo.notFound.desc': '您訪問的頁面不存在或已移動，請返回首頁或通過導航繼續瀏覽。',
  'seo.notFound.keywords': 'GEEL TEC, 404, 頁面未找到',
};
